import { render, staticRenderFns } from "./SampleDetailsModal.vue?vue&type=template&id=68da6836&"
import script from "./SampleDetailsModal.vue?vue&type=script&lang=js&"
export * from "./SampleDetailsModal.vue?vue&type=script&lang=js&"
import style0 from "./SampleDetailsModal.vue?vue&type=style&index=0&id=68da6836&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports